import React from "react";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";

//Funcion para las Acciones
export const PermissionWrapper = ({ action, children }) => {
  const selectProperties = createSelector(
    (state) => state.Login,
    (login) => ({
      rolesUser: login.roles || [], // Asegurar que rolesUser siempre sea un array
      permissionsUser: login.permissions || [],
    })
  );

  const { rolesUser, permissionsUser } = useSelector(selectProperties);
  const isAdmin = rolesUser?.some((role) => role.name === "ENTITY_ROLE");
  // console.log(isAdmin); // true

  // Si es admin, tiene acceso total
  if (isAdmin) return <>{children}</>;

  // Extraer permisos asignados al usuario
  const userPermissions = permissionsUser.map((perm: any) => perm.code);

  // Validar si tiene el permiso necesario
  const hasPermission = userPermissions.includes(action);

  if (!hasPermission) {
    return null; // No renderiza nada si no tiene permisos
  }

  return <>{children}</>;
};

//Funcion para las Acciones
export const PermissionActionWrapper = ({ action, children }) => {
  const selectProperties = createSelector(
    (state) => state.Login,
    (login) => ({
      // isAdmin: login.isAdmin || false, // Validar si el usuario es admin
      rolesUser: login.roles || [], // Asegurar que rolesUser siempre sea un array
      permissionsUser: login.permissions || [],
    })
  );

  // const { isAdmin, rolesUser, permissionsUser } = useSelector(selectProperties);
  const { rolesUser, permissionsUser } = useSelector(selectProperties);
  // console.log(permissionsUser);
  // console.log(rolesUser);
  const isAdmin = rolesUser?.some((role) => role.name === "ENTITY_ROLE");
  // console.log(permissionsUser); // true

  // Si es admin, tiene acceso total
  if (isAdmin) return <>{children}</>;

  // Extraer permisos asignados al usuario
  const userPermissions = permissionsUser.map((perm: any) => perm.code);

  // Validar si tiene el permiso necesario
  const hasPermission = userPermissions.includes(action);

  if (!hasPermission) {
    return null; // No renderiza nada si no tiene permisos
  }

  return <>{children}</>;
};

//Funcion para los roles
export const PermissionRoleWrapper = ({ roles, children }) => {
  const selectProperties = createSelector(
    (state) => state.Login,
    (login) => ({
      admin: login?.isAdmin ?? false, // Manejo seguro de `null`
      rolesUser: login.roles || [], // Asegurar que rolesUser siempre sea un array
    })
  );
  const { admin, rolesUser } = useSelector(selectProperties);
  if (admin) return <>{children}</>;

  // Extraer roles del usuario
  const userRoles = rolesUser.map((role: any) => role?.name).filter(Boolean);

  // Verificar si tiene un rol permitido
  const hasRole = roles.some((role: any) => userRoles.includes(role));

  return hasRole ? <>{children}</> : null;
};

// FUNCION QUE VALIDA SI LA ENTIDAD TIENE LOS PRODUCTOS
export const ProductsEntity = ({ prod, children }) => {
  const selectProperties = createSelector(
    (state) => state.Login,
    (login) => ({
      products: login.products || [], // Asegurar que rolesUser siempre sea un array
    })
  );

  const { products } = useSelector(selectProperties);
  // console.log(products);

  // Extraer permisos asignados al usuario
  const entityProducts = products.map((perm: any) => perm.name);
  // Validar si tiene el permiso necesario
  const hasProducts = prod.some((product: any) =>
    entityProducts.includes(product)
  );
  if (!hasProducts) {
    return null; // No renderiza nada si no tiene permisos
  }
  return <>{children}</>;
};
